$(document).ready(function () {
// Alle <g>-Elemente mit der Klasse "highcharts-label" auswählen
	const allElements = document.querySelectorAll('g.highcharts-label');

// Map zur Zählung von Klassen mit Zahlen am Ende
	const classCount = {};

// Iteriere über alle Elemente und zähle die Abschlussklassen
	allElements.forEach(el => {
		const match = [...el.classList].find(cls => cls.match(/highcharts-data-label-color-\d+/));
		if (match && match !== 'highcharts-data-label-color-0') {
			classCount[match] = (classCount[match] || 0) + 1;
		}
	});

// Selektiere das zweite Element für jede Klasse, die zweimal vorkommt
	allElements.forEach(el => {
		const match = [...el.classList].find(cls => cls.match(/highcharts-data-label-color-\d+/));
		if (match && classCount[match] === 2) {
			const elementsWithSameClass = [...allElements].filter(e => e.classList.contains(match));
			if (elementsWithSameClass[1] === el) {
				// Das zweite Element mit dieser speziellen Klasse wird versteckt
				el.style.display = 'none';
				console.log(`Zweites Element mit Klasse ${match} versteckt.`);
			}
		}
	})
});
